/* eslint-disable import/prefer-default-export */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import isNil from 'lodash/isNil';

/**
 * This class represents the utility functions for connection status of aircraft.
 */
const GIGA_CONVERSION = 1000000000;
const GIGABYTES_UNIT = 'GB';

const MEGA_CONVERSION = 1000000;
const MEGABYTES_UNIT = 'MB';

const KILO_CONVERSION = 1000;
const KILOBYTES_UNIT = 'KB';

const BYTES_UNIT = 'Bytes';

// Convert raw number of bytes to Gigabytes.
export const toGiga = (raw: number): string => {
  const result = raw / GIGA_CONVERSION;
  return result.toFixed(2);
};

// Convert raw number of bytes to Megabytes.
export const toMega = (raw: number): string => {
  const result = raw / MEGA_CONVERSION;
  return result.toFixed(2);
};

// Convert raw number of bytes to Kilobytes.
export const toKilo = (raw: number): string => {
  const result = raw / KILO_CONVERSION;
  return result.toFixed(2);
};

// Convert bytes) to the appropriate unit and append the unit string
export const bytesToUnitString = (numBytes: number | null | undefined): string => {
  if (isNil(numBytes)) {
    return '';
  }

  if (numBytes >= GIGA_CONVERSION) {
    return `${toGiga(numBytes)} ${GIGABYTES_UNIT}`;
  } else if (numBytes >= MEGA_CONVERSION) {
    return `${toMega(numBytes)} ${MEGABYTES_UNIT}`;
  } else if (numBytes >= KILO_CONVERSION) {
    return `${toKilo(numBytes)} ${KILOBYTES_UNIT}`;
  } else {
    return `${numBytes} ${BYTES_UNIT}`;
  }
};

// Convert Kilobytes to Megabytes
export const kiloToMega = (kilo: number): string => {
  const result = kilo / KILO_CONVERSION;
  return result.toFixed(2);
};